module.exports = "/_next/static/images/DataPipeline@2x-d43ca933448aef8745a2ebf787cb587c.webp";